import { BeMenu, BeMenuItem, BeMenuSeparator, BeRow } from "@beos-css/react/index.ts";

export function MenuDemo() {
	return (
		<section id="demo-menu">
			<h2>Menu (BMenu / BMenuItem)</h2>
			<p>
				BMenu's column layout and every item state, with the metrics confirmed against stock R5. The check and the submenu caret are
				generated SVG rather than pasted art — one <code>&lt;rect&gt;</code> per pixel run, tinted off the menu face the way{" "}
				<code>DrawMarkSymbol</code> and <code>DrawSubmenuSymbol</code> tint them — so a palette change still reaches them.
			</p>
			<p>
				Rest on <b>Submenu</b> to open its child, or press <kbd>→</kbd>; <kbd>←</kbd> closes it and <kbd>↑</kbd>/<kbd>↓</kbd> walk the
				items. R5 tracks menus with the mouse button held — this does not, deliberately.
			</p>
			<BeRow wrap gap="row" align="start">
				<BeMenu aria-label="States">
					<BeMenuItem onSelect={() => {}}>Default</BeMenuItem>
					<BeMenuItem selected onSelect={() => {}}>
						Selected
					</BeMenuItem>
					<BeMenuItem disabled>Disabled</BeMenuItem>
					<BeMenuSeparator />
					<BeMenuItem marked onSelect={() => {}}>
						Marked
					</BeMenuItem>
					<BeMenuItem marked selected onSelect={() => {}}>
						Marked, selected
					</BeMenuItem>
					<BeMenuItem marked disabled>
						Marked, disabled
					</BeMenuItem>
				</BeMenu>

				<BeMenu aria-label="Shortcuts">
					<BeMenuItem shortcut={{ key: "N" }} onSelect={() => {}}>
						New
					</BeMenuItem>
					<BeMenuItem shortcut={{ modifiers: ["shift", "command"], key: "S" }} onSelect={() => {}}>
						Save As…
					</BeMenuItem>
					<BeMenuItem shortcut={{ modifiers: ["option"], key: "W" }} disabled>
						Close All
					</BeMenuItem>
					<BeMenuItem shortcut={{ modifiers: ["control", "alt"], key: "T" }} onSelect={() => {}}>
						Terminal
					</BeMenuItem>
					<BeMenuItem shortcut={{ modifiers: ["win"], key: "E" }} onSelect={() => {}}>
						Explore
					</BeMenuItem>
					<BeMenuSeparator />
					<BeMenuItem shortcut="Del" onSelect={() => {}}>
						Delete
					</BeMenuItem>
				</BeMenu>

				<BeMenu aria-label="Submenus">
					<BeMenuItem
						submenu={
							<>
								<BeMenuItem onSelect={() => {}}>Child item</BeMenuItem>
								<BeMenuItem onSelect={() => {}}>Another child</BeMenuItem>
								<BeMenuSeparator />
								<BeMenuItem
									submenu={
										<>
											<BeMenuItem onSelect={() => {}}>Third level</BeMenuItem>
											<BeMenuItem onSelect={() => {}}>And again</BeMenuItem>
										</>
									}
								>
									Deeper
								</BeMenuItem>
							</>
						}
					>
						Submenu
					</BeMenuItem>
					<BeMenuItem submenu selected onSelect={() => {}}>
						Submenu, selected
					</BeMenuItem>
					<BeMenuItem submenu disabled>
						Submenu, disabled
					</BeMenuItem>
					<BeMenuSeparator />
					<BeMenuItem marked submenu onSelect={() => {}}>
						Marked, submenu
					</BeMenuItem>
				</BeMenu>
			</BeRow>
		</section>
	);
}
